import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ASSETS } from "../lib/constants";

const KEY = "hgdc_age_verified";

export const AgeGate = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(KEY)) setOpen(true);
  }, []);

  const confirm = () => {
    sessionStorage.setItem(KEY, "1");
    window.dispatchEvent(new Event("hgdc-age-verified"));
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-ink px-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          data-testid="age-gate"
        >
          <div className="absolute inset-0 opacity-20">
            <img src={ASSETS.exteriorWide} alt="" className="h-full w-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-ink/85" />
          <motion.div
            className="relative z-10 w-full max-w-lg border border-white/10 bg-ink-2/80 p-10 text-center backdrop-blur-xl md:p-14"
            initial={{ opacity: 0, y: 20, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          >
            <img src={ASSETS.logo} alt="Higher Ground DC" className="mx-auto mb-8 h-20 w-auto object-contain" />
            <p className="mb-3 text-xs uppercase tracking-[0.3em] text-gold">Age Verification Required</p>
            <h2 className="font-display text-2xl font-light uppercase tracking-[0.12em] text-white md:text-3xl">
              You must be 21 or older
            </h2>
            <p className="mx-auto mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              By entering, you confirm you are of legal age and agree to our terms. Washington, DC medical cannabis compliance applies.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <button
                onClick={confirm}
                data-testid="age-gate-confirm"
                className="group bg-gold px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-champagne"
              >
                I'm 21 or Older
              </button>
              <a
                href="https://www.google.com"
                data-testid="age-gate-deny"
                className="border border-white/15 px-8 py-4 text-xs font-medium uppercase tracking-[0.25em] text-white/70 transition-colors duration-300 hover:border-white/40 hover:text-white"
              >
                Under 21
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
